import { render, staticRenderFns } from "./ShoppingListTable.vue?vue&type=template&id=c91fad7c&"
import script from "./ShoppingListTable.vue?vue&type=script&lang=js&"
export * from "./ShoppingListTable.vue?vue&type=script&lang=js&"
import style0 from "./ShoppingListTable.vue?vue&type=style&index=0&module=true&lang=css&"

var cssModules = {}
var disposed = false

function injectStyles (context) {
  if (disposed) return
  
        cssModules["$style"] = (style0.locals || style0)
        Object.defineProperty(this, "$style", {
          configurable: true,
          get: function () {
            return cssModules["$style"]
          }
        })
      
}


  module.hot && module.hot.dispose(function (data) {
    disposed = true
  })



        module.hot && module.hot.accept(["./ShoppingListTable.vue?vue&type=style&index=0&module=true&lang=css&"], function () {
          var oldLocals = cssModules["$style"]
          if (oldLocals) {
            var newLocals = require("./ShoppingListTable.vue?vue&type=style&index=0&module=true&lang=css&")
            if (JSON.stringify(newLocals) !== JSON.stringify(oldLocals)) {
              cssModules["$style"] = newLocals
              require("/builds/driehle1/rezeptdatenbank/node_modules/vue-hot-reload-api/dist/index.js").rerender("c91fad7c")
            }
          }
        })

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/driehle1/rezeptdatenbank/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c91fad7c')) {
      api.createRecord('c91fad7c', component.options)
    } else {
      api.reload('c91fad7c', component.options)
    }
    module.hot.accept("./ShoppingListTable.vue?vue&type=template&id=c91fad7c&", function () {
      api.rerender('c91fad7c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "assets/trip-shopping-list/ShoppingListTable.vue"
export default component.exports